import { createSlice } from "@reduxjs/toolkit";
import {
  fetchFeeScheduleProviderDetails,
  fetchPreferredNetworks,
  fetchFeeSchedules,
  fetchFeeScheduleFormDetails,
} from "./feeScheduleActions";
import { getApiErrorMessage } from "../../../utils/commonUtilities";

const feeScheduleProviderDetails = createSlice({
  name: "feeScheduleProviderDetails",
  initialState: {
    isLoadingProviderDetails: false,
    errorProviderDetails: null,
    errorProviderDetailsMsg: "",
    feeScheduleProviderDetails: [],
  },
  reducers: {
    clearFeeScheduleErrors: (state) => {
      state.errorProviderDetails = null;
      state.errorProviderDetailsMsg = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeeScheduleProviderDetails.pending, (state) => {
        state.isLoadingProviderDetails = true;
        state.errorProviderDetails = null;
        state.errorProviderDetailsMsg = "";
      })
      .addCase(fetchFeeScheduleProviderDetails.fulfilled, (state, action) => {
        state.isLoadingProviderDetails = false;
        if (!action.payload || !action.payload.data) {
          state.errorProviderDetails = true;
          state.feeScheduleProviderDetails = [];
          state.errorProviderDetailsMsg = getApiErrorMessage(action.payload.metadata?.outcome.status);
        } else {
          state.errorProviderDetails = false;
          state.feeScheduleProviderDetails = action.payload;
        }
      })
      .addCase(fetchFeeScheduleProviderDetails.rejected, (state) => {
        state.isLoadingProviderDetails = false;
        state.errorProviderDetails = true;
        state.errorProviderDetailsMsg = "Something Went Wrong!. Please try again later.";
      });
  },
});

const preferredNetworksSlice = createSlice({
  name: "preferredNetworks",
  initialState: {
    isLoadingPreferredNetworks: false,
    errorPreferredNetworks: null,
    errorPreferredNetworksMsg: "",
    preferredNetworks: [],
  },
  reducers: {
    clearPreferredNetworksErrors: (state) => {
      state.errorPreferredNetworks = null;
      state.errorPreferredNetworksMsg = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPreferredNetworks.pending, (state) => {
        state.isLoadingPreferredNetworks = true;
        state.errorPreferredNetworks = null;
        state.errorPreferredNetworksMsg = "";
      })
      .addCase(fetchPreferredNetworks.fulfilled, (state, action) => {
        state.isLoadingPreferredNetworks = false;
        if (!action.payload || !action.payload.data) {
          state.errorPreferredNetworks = true;
          state.errorPreferredNetworksMsg = getApiErrorMessage(action.payload.metadata?.outcome.status);
        } else {
          state.errorPreferredNetworks = false;
          state.preferredNetworks = action.payload;
        }
      })
      .addCase(fetchPreferredNetworks.rejected, (state) => {
        state.isLoadingPreferredNetworks = false;
        state.errorPreferredNetworks = true;
        state.errorPreferredNetworksMsg = "Something Went Wrong!. Please try again later.";
      });
  },
});

const feeScheduleSlice = createSlice({
  name: "feeSchedules",
  initialState: {
    isLoadingFeeSchedules: false,
    errorFeeSchedules: null,
    errorFeeSchedulesMsg: "",
    feeSchedules: [],
  },
  reducers: {
    clearFeeSchedulesErrors: (state) => {
      state.errorFeeSchedules = null;
      state.errorFeeSchedulesMsg = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeeSchedules.pending, (state) => {
        state.isLoadingFeeSchedules = true;
        state.errorFeeSchedules = null;
        state.errorFeeSchedulesMsg = "";
      })
      .addCase(fetchFeeSchedules.fulfilled, (state, action) => {
        state.isLoadingFeeSchedules = false;
        if (!action.payload || !action.payload.data) {
          state.errorFeeSchedules = true;
          state.errorFeeSchedulesMsg = getApiErrorMessage(action.payload.metadata?.outcome.status);
        } else {
          state.errorFeeSchedules = false;
          state.feeSchedules = action.payload;
        }
      })
      .addCase(fetchFeeSchedules.rejected, (state) => {
        state.isLoadingFeeSchedules = false;
        state.errorFeeSchedules = true;
        state.errorFeeSchedulesMsg = "Something Went Wrong!. Please try again later.";
      });
  },
});

const feeScheduleFormDetails = createSlice({
  name: "feeScheduleFormDetails",
  initialState: {
    isLoadingFormDetails: false,
    errorFormDetails: null,
    errorFormDetailsMsg: "",
    feeScheduleFormDetails: [],
    formDetailsDeleteError: "",
    formDetailsDeleteLoading: false,
  },
  reducers: {
    clearFormDetailsErrors: (state) => {
      state.errorFormDetails = null;
      state.errorFormDetailsMsg = "";
      state.formDetailsDeleteError = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeeScheduleFormDetails.pending, (state) => {
        state.isLoadingFormDetails = true;
        state.errorFormDetails = null;
        state.errorFormDetailsMsg = "";
      })
      .addCase(fetchFeeScheduleFormDetails.fulfilled, (state, action) => {
        state.isLoadingFormDetails = false;
        if (!action.payload || !action.payload.data) {
          state.errorFormDetails = true;
          state.errorFormDetailsMsg = getApiErrorMessage(action.payload.metadata?.outcome.status);
        } else {
          state.errorFormDetails = false;
          state.feeScheduleFormDetails = action.payload;
        }
      })
      .addCase(fetchFeeScheduleFormDetails.rejected, (state) => {
        state.isLoadingFormDetails = false;
        state.errorFormDetails = true;
        state.errorFormDetailsMsg = "Something Went Wrong!. Please try again later.";
      });
  },
});

export const { clearFeeScheduleErrors } = feeScheduleProviderDetails.actions;
export const { clearPreferredNetworksErrors } = preferredNetworksSlice.actions;
export const { clearFeeSchedulesErrors } = feeScheduleSlice.actions;
export const { clearFormDetailsErrors } = feeScheduleFormDetails.actions;

export const feeScheduleProviderDetailsReducer = feeScheduleProviderDetails.reducer;
export const feeSchedulePreferredNetworksReducer = preferredNetworksSlice.reducer;
export const feeSchedulesReducer = feeScheduleSlice.reducer;
export const feeScheduleFormDetailsReducer = feeScheduleFormDetails.reducer;